import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LucideAngularModule, Lock, Home } from 'lucide-angular';
import { UrlService } from '../../services/url.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  imports: [CommonModule, RouterModule, LucideAngularModule],
  template: `
    <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div class="max-w-md w-full text-center">
        <div class="mb-2">
          <lucide-icon
            [img]="LockIcon"
            [size]="48"
            class="mx-auto text-red-500"
          ></lucide-icon>
        </div>
        <h1 class="text-6xl font-bold text-gray-900 mb-4">403</h1>
        <h2 class="text-2xl font-semibold text-gray-800 mb-4">
          Accès interdit
        </h2>
        <p class="text-gray-600 mb-8">
          Désolé, vous n'avez pas l'autorisation d'accéder à cette page. Cette
          fonctionnalité est actuellement désactivée.
        </p>
        <button
          (click)="goToDashboard()"
          class="inline-flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:text-gray-800 transition-colors underline"
        >
          <lucide-icon [img]="HomeIcon" [size]="16"></lucide-icon>
          Retour au tableau de bord
        </button>
      </div>
    </div>
  `,
})
export class ForbiddenComponent {
  readonly LockIcon = Lock;
  readonly HomeIcon = Home;

  constructor(
    private router: Router,
    private urlService: UrlService
  ) {}

  goToDashboard(): void {
    this.router.navigate(this.urlService.buildRouteSegments('passport/dashboard'));
  }
}
